import productPermissionsService from "@irati/permissions/services/products";
import authentication from "@irati/auth";
export default function hasMultipleOffices(tenant) {
    if (tenant === void 0) { tenant = authentication.userTenant(); }
    return productPermissionsService.get(tenant).then(function (_a) {
        var permissionsForAllTeams = _a.permissionsForAllTeams;
        var teams = currentlySupportedTeamSetups(permissionsForAllTeams);
        return teams.length > 0;
    });
}
export function officesForTenant(tenant) {
    if (tenant === void 0) { tenant = authentication.userTenant(); }
    return productPermissionsService.get(tenant).then(function (_a) {
        var permissionsForAllTeams = _a.permissionsForAllTeams;
        return currentlySupportedTeamSetups(permissionsForAllTeams);
    });
}
function currentlySupportedTeamSetups(permissionsForAllTeams) {
    // currently only show offices if the tenant has teams with perks permissions assigned to them
    return permissionsForAllTeams.filter(function (test) { return test.permissions.deals.enabled; });
}
